// Saves the inbox panel layout (FRO-138) to PATCH /settings/account/layout, and keeps a Turbo morph
// from undoing it while it is not saved yet.
//
// The server renders the saved widths and collapse classes onto .app, so once a save has landed a
// morph refresh (project-watcher broadcast_refresh_to fires often) paints what the client already
// shows. Before that — mid-drag, inside the keyboard debounce, or with the PATCH in flight — a morph
// would put the OLD server version back, the FRO-129 class of bug. While anything holds, the
// style/class/aria attributes of .app and of every element marked data-layout-state are left alone.
//
// Shared by panel-resize and sidebar-collapse, which is why it is a module and not either of them:
// the settings and report shells have the sidebar toggle but no panel-resize.

let holds = 0

export function hold() {
  holds += 1
  let released = false
  return () => {
    if (released) return
    released = true
    holds -= 1
  }
}

export async function saveLayout(url, attributes) {
  if (!url) return
  const release = hold()
  try {
    await fetch(url, {
      method: "PATCH",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ layout: attributes })
    })
  } catch {
    // Offline or a blip: the layout still applies on this page, it just won't follow a reload.
  } finally {
    release()
  }
}

const GUARDED = /^(style|class|aria-.*)$/

document.addEventListener("turbo:before-morph-attribute", (event) => {
  if (holds === 0 || !GUARDED.test(event.detail.attributeName)) return
  if (event.target.matches?.(".app, [data-layout-state]")) event.preventDefault()
})
